import React from 'react';

import { Container } from './styledComponents';

const Marker = (props) => {
  const { color, icon } = props;

  return <Container color={color} icon={icon} />;
};

export default Marker;
